// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutHeadDark_container__LdVrW","runAnimation":"AboutHeadDark_runAnimation__yoh_b","FadeFromBottomWithDelay":"AboutHeadDark_FadeFromBottomWithDelay__7pWwu"};